import "./index.css";
import { Skeleton } from "@/ui-kit";
import { useBreakpoints } from "@/hooks/useBreakpoints";

type IProps = {
  header?: boolean;
  filters?: boolean;
};

export const PageSuspense = ({ header, filters }: IProps) => {
  const { isMobile } = useBreakpoints();
  const size = isMobile ? "52px" : "42px";

  return (
    <div className="page-suspense">
      {header !== false && (
        <div className="page-suspense-header">
          <Skeleton width="12.5rem" height="2.625rem" />
        </div>
      )}
      {filters !== false && (
        <div className="filters-suspense">
          <Skeleton width="16.25rem" height={size} />
          <Skeleton width={size} height={size} className="shrink-0" />
        </div>
      )}
    </div>
  );
};
